<div class="inline-glossary-heading mt_1">

</div>
<div *ngIf="glossaryTermId!=''">
  <div class="mx-2-5 mb-1" *ngIf="contacts.length>0">
    <div class="my-1 glossary-content-heading" [innerHTML]="glossaryData.formattedGlossaryTitle" (contextmenu)="onRightClick($event)" (click)="OpenLink($event)">
    </div>
    <div class="mt_0_5rem" *ngFor="let contact of contacts">
      <div>
      <span *ngIf="glossaryData.topic!=null && glossaryData.topic.length > 0" class="small-text-heading cursor-pointer right-Overlay mr_0_5rem" [termId]='glossaryTermId' data-parent="inline-glossary" id="glossary-term-usage" [topicData]="contact" appHostListenerClick>{{glossaryTermUsage}}</span>
    </div>
      <span class="text-transform-uppercase bold topic font-black" *ngIf=" glossaryData.topic.length == 0">
        {{noLinks}}
      </span>
    </div>
  </div>
  
  <div class="mx-2-5 mb-3-5 mt-2 glossary-content">
    <div [innerHTML]="glossaryData.body"  (contextmenu)="onRightClick($event)" (click)="OpenLink($event)">
    </div>
  </div>
</div>


<div class="inline-glossary-heading mt_1" *ngIf="glossaryTermId==''">No records found.</div>


